import {NgModule} from '@angular/core';
import {SafeHtmlPipe} from './safe-html.pipe';
import {CommonModule} from '@angular/common';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        SafeHtmlPipe
    ],
    exports: [
        SafeHtmlPipe
    ]
})
export class SafeHtmlPipeModule {
}



// WEBPACK FOOTER //
// /app/src/app/pipes/safe-html/safe-html-pipe.module.ts